import React from "react"

const ActionBarTop = () => {
  return (
    <section className="top-bar">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="top-number">
              <p>
                <i className="fa fa-phone-square" /> +92 334 3868945
              </p>
            </div>
          </div>

          <div className="col-sm-6 col-xs-12">
            <div className="social ">
              <ul className="list-inline social-share">
                <li>
                  <a href="https://facebook.com/morosoftpk" target="_blank">
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/morosoftpk" target="_blank">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com/morosoftpk" target="_blank">
                    <i className="fa fa-instagram" />
                  </a>
                </li>
                <li>
                  <a href="https://dribbble.com/morosoftpk" target="_blank">
                    <i className="fa fa-dribbble" />
                  </a>
                </li>
                <li>
                  <a href="https://linkedin.com/morosoftpk" target="_blank">
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ActionBarTop
